import React, { useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { IntlMessage } from "app/components/Intl";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import FileUploadArea, { FileType } from "../../../../components/FileUploadArea";
const UploadFileDialog = (props) => {
  const { open, setOpen, onConfirm, types, isOCR } = props;
  const [hasFiles, setHasFiles] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState(void 0);
  return /* @__PURE__ */ React.createElement(Dialog, { fullWidth: true, maxWidth: "md", open, onClose: () => setOpen(false), "aria-labelledby": "confirm-dialog" }, /* @__PURE__ */ React.createElement(DialogTitle, { id: "upload-file-dialog" }, /* @__PURE__ */ React.createElement(FormattedMessage, { id: isOCR ? "upload.file.ocr.title" : "upload.file.title" })), /* @__PURE__ */ React.createElement(DialogContent, null, /* @__PURE__ */ React.createElement(DialogContentText, { marginBottom: (theme) => theme.spacing(1) }, /* @__PURE__ */ React.createElement(FormattedMessage, { id: isOCR ? "upload.file.ocr.helpMessage" : "upload.file.helpMessage" })), /* @__PURE__ */ React.createElement(
    FileUploadArea,
    {
      types: types ?? [FileType.Csv, FileType.Xml],
      disabled: false,
      showSuccessMessage: false,
      onChange: (files) => {
        setHasFiles(files.length > 0);
        setUploadedFiles(files);
      }
    }
  )), /* @__PURE__ */ React.createElement(DialogActions, null, /* @__PURE__ */ React.createElement(Button, { variant: "outlined", onClick: () => setOpen(false) }, /* @__PURE__ */ React.createElement(IntlMessage, { value: "no" })), /* @__PURE__ */ React.createElement(
    Button,
    {
      variant: "contained",
      onClick: () => {
        setOpen(false);
        onConfirm(uploadedFiles);
      },
      disabled: !hasFiles
    },
    /* @__PURE__ */ React.createElement(FormattedMessage, { id: "button.start" })
  )));
};
UploadFileDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  onConfirm: PropTypes.func,
  types: PropTypes.arrayOf(PropTypes.string),
  isOCR: PropTypes.bool
};
export default UploadFileDialog;
